import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

interface HeaderProps {
  onSearchChange?: (value: string) => void;
  searchValue?: string;
}

export default function Header({ onSearchChange, searchValue }: HeaderProps) {
  const { user, logout } = useAuth();

  return (
    <header className="bg-white border-b border-stone-200 shadow-sm sticky top-0 z-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between gap-4">
        <Link to="/" className="flex-shrink-0 no-underline">
          <span
            className="text-2xl font-semibold tracking-tight text-herb"
            style={{ fontFamily: "Georgia, serif" }}
          >
            Sous & Chef
          </span>
        </Link>

        {onSearchChange !== undefined && (
          <div className="flex-1 max-w-sm">
            <input
              type="search"
              placeholder="Search recipes..."
              value={searchValue ?? ""}
              onChange={(e) => onSearchChange(e.target.value)}
              className="w-full rounded-full border border-stone-300 px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-herb focus:border-transparent bg-stone-50"
            />
          </div>
        )}

        <div className="flex items-center gap-3">
          {user ? (
            <>
              <Link
                to="/recipe/new"
                className="text-sm font-medium text-white bg-herb hover:bg-herb-light px-4 py-2 rounded-full transition-colors"
              >
                + Add Recipe
              </Link>
              <span className="text-sm text-stone-500 hidden sm:block">{user.email}</span>
              <button
                onClick={logout}
                className="text-sm text-stone-500 hover:text-stone-800 px-3 py-2 rounded-full border border-stone-200 hover:border-stone-300 transition-colors"
              >
                Log out
              </button>
            </>
          ) : (
            <Link
              to="/login"
              className="text-sm text-stone-500 hover:text-stone-800 px-4 py-2 rounded-full border border-stone-200 hover:border-stone-300 transition-colors"
            >
              Log in
            </Link>
          )}
        </div>
      </div>
    </header>
  );
}
